export class CountryCodeVm{
    IsoCode: string = "";
    CountryName: string = "";
    IsEuracis: boolean = false;
    TachonetCode: string = "";

}